"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import API from "@ym-framework/api-utils";
export class AccountAuth {
  static authAfter(session) {
    return __async(this, null, function* () {
      if (!session.mark.is("NOVICE_GUIDE")) {
        yield API.put(`api://base.local/storages/users/${session.id}/preference/novice`, {
          "flag": true
        });
      }
    });
  }
}
